(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_hero-slide"] && !Shopify.designMode) return;
  try {
    (function () {
    // Videos in a slide that are currently displayed (desktop and mobile videos are toggled with CSS)
    function visibleVideos(slide) {
      return Array.prototype.filter.call(slide.querySelectorAll('video'), function (video) {
        return video.getClientRects().length > 0;
      });
    }

    function setButton(button, soundOn) {
      button.classList.toggle('is-sound-on', soundOn);
      button.setAttribute('aria-pressed', String(soundOn));
      button.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
    }

    function muteSlide(slide) {
      slide.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
      });
      var button = slide.querySelector('[data-hero-sound]');
      if (button) setButton(button, false);
    }

    // Mute a slide again once it is no longer on screen (carousel moved on or page scrolled away)
    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.intersectionRatio < 0.5) {
                  muteSlide(entry.target);
                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: [0, 0.5] }
          )
        : null;

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-hero-sound]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var slide = button.closest('.hero__slide');
      if (!slide) return;

      var videos = visibleVideos(slide);
      if (!videos.length) return;

      var turnOn = videos[0].muted;

      if (turnOn) {
        // Only one hero video plays sound at a time
        document.querySelectorAll('.hero__slide').forEach(function (other) {
          if (other !== slide) muteSlide(other);
        });
      }

      videos.forEach(function (video) {
        video.muted = !turnOn;
        if (turnOn) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      });

      setButton(button, turnOn);
      if (turnOn && observer) observer.observe(slide);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function isWishlistClick(event) {
      // composedPath() works even if the wishlist widget or card markup
      // lives inside a custom element / shadow root, where event.target
      // would otherwise be retargeted to the shadow host.
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.classList && node.classList.contains('wishlist-engine')) {
          return true;
        }
      }
      return false;
    }

    // Bound once, directly on document, with no DOMContentLoaded gate -
    // this guarantees it's active for cards rendered later (filtering,
    // infinite scroll, section re-render, etc.) and isn't missed if
    // DOMContentLoaded already fired before this script executed.
    document.addEventListener('click', function (event) {
      if (isWishlistClick(event)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    ['mousedown', 'pointerdown', 'touchstart'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (isWishlistClick(event)) {
          event.stopPropagation();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
